<template>
    <div class="row" style="background: #fff;">
       <v-container>
         <v-text-field v-if="generalmarchands==undefined" color="primary" loading  disabled></v-text-field>
                <ul >

                  <!--<li>
                          <v-row>
                              <v-col md="8" sm="9" style="margin-top: 0.1%;">
                                 <span style="font-size: 20pt"> - </span> {{$t('generalsetting.ddp')}}
                              </v-col>

                              <v-col md="2" sm="2" style="margin: 0%; padding: 0%;">
                                  <v-select :items="devises" item-text='_code_alpha' item-value="_id" return-object
                                   v-model="generalsettings.ddp" solo></v-select>
                              </v-col>
                              <v-col md="1" sm="1" style="margin-left: 0%; padding: 0%;text-align: right">
                                <v-btn :disbled="submitting2" style="margin-right: 2%; height:8vh"
                                color="primary"  @click.prevent="save(2)">

                                    <span v-if='!submitting2'> <v-icon> mdi-content-save </v-icon> </span>
                                    <span v-else><v-progress-circular
                                      :width="1"
                                      color="white"
                                      indeterminate
                                      :size="25"
                                    ></v-progress-circular> </span>

                                </v-btn>
                              </v-col>
                          </v-row>
                  </li>-->
                  <li>
                          <v-row>
                              <v-col md="8" sm="9" style="margin-top: 0.1%;">
                                 <span style="font-size: 20pt"> - </span> {{$t('generalsetting.ddc')}}
                                 <span v-if="infomarchand" style="color: #29B3A6; font-weight: bold|italic; ">{{infomarchand._company}}</span>
                              </v-col>

                              <v-col md="2" sm="2" style="margin: 0%; padding: 0%;">
                                  <v-select :items="devises" item-text='_code_alpha' item-value="_id" return-object  v-model="generalsettings.ddc" solo></v-select>
                              </v-col>
                              <v-col md="1" sm="1" style="margin-right: 0px;margin-left: 0px; padding: 0%;text-align: right">
                                <v-btn :disbled="submitting" style=""  color="primary"  @click.prevent="save(1)">
                                    <span v-if='!submitting'> <v-icon> mdi-content-save </v-icon> </span>
                                    <span v-else><v-progress-circular
                                      :width="1"
                                      color="white"
                                      indeterminate
                                      :size="25"
                                    ></v-progress-circular> </span>

                                </v-btn>
                              </v-col>
                          </v-row>
                  </li>
                </ul>

                <!-- <v-row>
                    <v-spacer></v-spacer>


                    <v-btn :disbled="submitting" style="margin-right: 2%" color="primary"  @click.prevent="save(1)">

                        <span v-if='!submitting'>{{$t('save')}} </span>
                        <span v-else><v-progress-circular
                          :width="1"
                          color="white"
                          indeterminate
                          :size="25"
                        ></v-progress-circular> {{$t('saving')}} </span>

                    </v-btn>
                </v-row> -->


       </v-container>

       <v-snackbar
               v-model="customSnack.snackbar"
                :timeout="customSnack.snacktimeout"

       >
           <span :color="customSnack.snackcolor">{{ customSnack.text }}</span>

           <template v-slot:action="{ attrs }">
               <v-btn
                       :color="customSnack.snackcolor"
                       text
                       v-bind="attrs"
                       @click="customSnack.snackbar = false"
               >
                   {{$t("fermer")}}
               </v-btn>
           </template>
       </v-snackbar>
    </div>
</template>

<script>
    import {mapState} from "vuex";
    import helpers from "../../../../mixins/helpers";


    export default {
        name: "GeneralSetting",
        mixins:[helpers(this)],
        data (){
            return{
              customSnack:{
                    snackbar: false,
                    text: "",
                    snackcolor:"black",
                    snackbBtnColor:"white",
                    snacktimeout:2000
                  },
                  infomarchand:undefined,
            snackbar: false,
            text: '',
                submitting: false,
                  submitting2: false,

              generalsettings:{
                ddc:'',
                ddp:'',
              },
              errors:undefined
            }
        },
        computed:{
          ...mapState('generalsettings/',['generalmarchands']),
          ...mapState('devises/', ['devises']),
          ...mapState('dashboard',['wallets']),

        },
        mounted() {
                this.infomarchand = this.$store.getters.marchand;

                this.$store.dispatch('generalsettings/getGeneralSettingMarchand',this.$store.getters.marchand._id).then(response => {
                    console.log('getGeneralSetting',response)
                    this.generalsettings = response.generalsettings;
                    console.log("this.generalsettings",this.generalsettings)

                });

                this.$store.dispatch('devises/getDevises').then(response => {
                    window.console.log('devises', response)
                });

                this.$store.dispatch('dashboard/wallets').then((response)=>{
                    console.log('dashborad wallets',response)
                    this.infomarchand = response.wallets;

                });

        },
        methods:{

                loadsub(pos,state){
                     switch(pos)
                    {
                        case 1:
                            this.submitting = state;
                        break;

                        case 2:
                            this.submitting2 = state;
                        break;

                        case 3:
                            this.submitting3 = state;
                        break;


                    }
                },

             save(pos) {
                this.customSnack.snackbar = false;
                let id = '';
                let value = '';

                if(pos==1)
                {
                  //this.$store.getters.marchand
                    if(this.infomarchand.marchand_wallet._amount==0)
                    {
                      id = this.infomarchand.marchand_wallet._id;
                      if(this.generalsettings && !this.generalsettings.ddc._id){
                        this.customSnack.snackbar = true;
                        this.customSnack.text = this.$t("generalsetting.ddperrorvalue");
                        this.customSnack.snackcolor="red";
                        this.customSnack.snackbBtnColor="black";
                        this.customSnack.snacktimeout=0;
                        return;
                      }
                      value = this.generalsettings.ddc._id;
                    }else{
                      this.customSnack.snackbar = true;
                      this.customSnack.text = this.$t("generalsetting.erroramountwallet");
                      this.customSnack.snackcolor="red";
                      this.customSnack.snackbBtnColor="black";
                      this.customSnack.snacktimeout=0;
                      return;
                    }
                }

                if(pos==2)
                {
                  //this.$store.getters.marchand
                    if(this.generalsettings && this.infomarchand.user_wallet._amount==0)
                    {
                      id = this.infomarchand.user_wallet._id;
                      if(this.generalsettings && !this.generalsettings.ddp._id){
                        this.customSnack.snackbar = true;
                        this.customSnack.text = this.$t("generalsetting.ddperrorvalue");
                        this.customSnack.snackcolor="red";
                        this.customSnack.snackbBtnColor="black";
                        this.customSnack.snacktimeout=0;
                        return;
                      }
                      value = this.generalsettings.ddp._id;
                    }else{
                      this.customSnack.snackbar = true;
                      this.customSnack.text = this.$t("generalsetting.erroramountwallet");
                      this.customSnack.snackcolor="red";
                      this.customSnack.snackbBtnColor="black";
                      this.customSnack.snacktimeout=0;
                      return;
                    }
                }




                let data = new FormData();
                //console.log("SETTING",this.generalsettings)

                this.loadsub(pos,true);
                data.append("generalsettings", value);
                // data.append("marchand_wallet", this.infomarchand.marchand_wallet._id);
                // data.append("user_wallet", this.infomarchand.user_wallet._id);
                data.append("id", id);
                data.append("pos", pos);


                let mineroute = 'generalsettings/updateGeneralSettingMarchand';
                this.$store.dispatch(mineroute, data).then((response) => {
                    console.log("response",response);
                    this.loadsub(pos, false);
                      this.showSnackDefault(response);
                      this.generalsettings = response.data.generalsettings;
                })
            },
        },
    }

</script>

<style scoped>
  ul {
    font-size: 12pt;

   list-style-type: none;
}

li{
    margin-top: 1.8%;
}


</style>
